package pl.nickers.match3.ecs

import pl.nickers.match3.SoundEvent

internal class FallResolveSystem : BaseSystem() {
    private lateinit var fallingMapper: ComponentMapper<FallingComponent>
    private lateinit var teleportingMapper: ComponentMapper<TeleportingComponent>
    private lateinit var justMovedMapper: ComponentMapper<JustMovedComponent>

    override fun initialize() {
        fallingMapper = world.mapper()
        teleportingMapper = world.mapper()
        justMovedMapper = world.mapper()
    }

    override fun processSystem() {
        val board = world.boardState() ?: return
        if (board.phase != GamePhase.GRAVITY) return
        val falling = world.getEntitiesForAspect(Aspect.all(FallingComponent::class)).toList()
        val teleporting = world.getEntitiesForAspect(Aspect.all(TeleportingComponent::class)).toList()
        if (falling.isEmpty() && teleporting.isEmpty()) return
        var hadAnyFall = false
        for (id in falling) {
            val f = fallingMapper[id]!!
            if (f.fromRow >= 0) {
                hadAnyFall = true
                justMovedMapper.set(id, JustMovedComponent())
            }
            fallingMapper.remove(id)
        }
        for (id in teleporting) {
            justMovedMapper.set(id, JustMovedComponent())
            teleportingMapper.remove(id)
        }
        if (hadAnyFall) {
            // ASSUMPTION: enqueue JELLIES_FALL whenever pieces complete their fall.
            // One sound per frame, even if multiple pieces land simultaneously.
            world.enqueueAudioEvent(SoundEvent.JELLIES_FALL)
        }
        board.didWork = true
    }
}
